/// <reference path="../types/index.d.ts" />

import '../client_forms/bingemanscc/style.css';
import FormStructure from './bingemanscc/form_structure';

export default FormStructure;